import { inject, Injectable } from '@angular/core';
import { I18nApiService } from '@app/api/services/i18n-api.service';
import { DefaultJsonFileLoader } from '@app/core/i18n/services/default-json-file-loader.service';
import { TranslationManagementService } from '@app/core/i18n/services/translation-management.service';
import { mergeDeep, TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { TranslationsSource } from 'src/environments/common/translations-source.enum';

@Injectable()
export class JsonFileLoader implements TranslateLoader {
  private readonly i18nApiService: I18nApiService = inject(I18nApiService);
  private readonly defaultJsonFileLoader: DefaultJsonFileLoader = inject(DefaultJsonFileLoader);
  private readonly translationManagementService: TranslationManagementService = inject(TranslationManagementService);

  public getTranslation(lang: string): Observable<TranslationObject> {
    if (this.translationManagementService.getTranslationsSource() === TranslationsSource.Remote) {
      return this.getRemoteTranslate(lang);
    } else {
      return this.getRemoteAndLocalTranslation(lang);
    }
  }

  private getRemoteAndLocalTranslation(lang: string): Observable<TranslationObject> {
    return forkJoin([this.defaultJsonFileLoader.loadTranslate(), this.getRemoteTranslate(lang)]).pipe(
      map(([local, remote]) => {
        if (this.translationManagementService.getTranslationsSource() === TranslationsSource.LocalAndRemote) {
          return mergeDeep(remote, local);
        }

        return mergeDeep(local, remote);
      })
    );
  }

  private getRemoteTranslate(lang: string): Observable<TranslationObject> {
    return this.i18nApiService.getTranslationObjectFromServer(lang).pipe(catchError(() => of({})));
  }
}
